import { createListLoadingReducer } from './utils';

export default createListLoadingReducer('COMPANY_CATEGORIES');
